export const HOTEL_INGREDIENT_SUFFIX = 'ht';
export const HOTEL_FILTERS_PREFIX = 'fltr:';
export const HOTEL_NAME_PREFIX = 'name:';
export const OLD_DESTINATION_PRODUCTS_PREFIX = ' ';
export const OLD_SELECTED_ROOMS_PREFIX = ':';
export const NEW_SELECTED_ROOMS_PREFIX = 'room:';
export const STAY_REFUNDABILITY_PREFIX = '.';
export const ROOM_PROP_PREFIX = ';';
export const SELECTION_PREFIX_SEPARATOR = ':';
export const STAY_REFUNDABILITY_CODE = 'rf';
export const SUGGESTION_ORDER_PREFIX = 'sug:';

export const enum SerializedAvailabilityOrder {
  None = '0',
  Cheapest = '1',
  Popular = '2',
}
